import axios from 'axios'

const ACCESS_TOKEN_KEY = process.env.REACT_APP_ACCESS_TOKEN_KEY || 'accessToken'
const REFRESH_TOKEN_KEY = process.env.REACT_APP_REFRESH_TOKEN_KEY || 'refreshToken'

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3000/apiClient'
})

function handleLogout() {
  sessionStorage.removeItem(ACCESS_TOKEN_KEY)
  sessionStorage.removeItem(REFRESH_TOKEN_KEY)

  if (typeof window !== 'undefined') {
    window.location.href = '/login'
  }
}

apiClient.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem(ACCESS_TOKEN_KEY)
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

apiClient.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalConfig = err.config

    if (originalConfig && originalConfig.url !== '/login' && originalConfig.url !== '/refreshToken' && err.response) {
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true

        const refreshToken = sessionStorage.getItem(REFRESH_TOKEN_KEY)
        if (!refreshToken) {
          handleLogout()
          return Promise.reject(err)
        }

        try {
          const rs = await apiClient.post('/refreshToken', { refreshToken })
          const { accessToken } = rs.data
          sessionStorage.setItem(ACCESS_TOKEN_KEY, accessToken)

          apiClient.defaults.headers.common.Authorization = `Bearer ${accessToken}`
          originalConfig.headers.Authorization = `Bearer ${accessToken}`

          return apiClient(originalConfig)
        } catch (_error) {
          if (process.env.NODE_ENV === 'development') {
          }
          handleLogout()
          return Promise.reject(_error)
        }
      }
    }

    return Promise.reject(err)
  }
)

export default apiClient
